export default __webpack_public_path__ + "static/media/PAFI_The Invitation of GMS 2021.43bb73e2.pdf";